import { css } from 'styled-components';

export const bracketLinkHoverStyle = css`
    position: relative; /* Needed for positioning pseudo-elements */
    display: inline-block; /* Helps with padding and layout */
    padding: 2px 4px; /* Add slight padding to make space for brackets */
    color: var(--text-muted);    /* Base color for footer/secondary links */
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease, opacity 0.3s ease; /* Add opacity for smooth bracket appearance */

    /* Hide brackets by default */
    &:before,
    &:after {
        color: var(--primary-color);
        position: absolute;
        top: 50%; /* Center vertically */
        transform: translateY(-50%); /* Fine-tune vertical centering */
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none; /* Prevent brackets from interfering with clicks */
    }

    &:before {
        content: "[";
        color: var(--primary-color);
        left: -4px; /* Adjust position as needed */
    }

    &:after {
        content: "]";
        color: var(--primary-color);
        right: -4px; /* Adjust position as needed */
    }

    /* Styles on hover */
    &:hover {
        color: var(--link-hover-color);
        /* Show brackets on hover */
        &:before,
        &:after {
            opacity: 1;
        }
    }
`;